import { KeyboardEvent, MouseEvent } from "react";
import { useAnimatedIcon } from "../../../../../../hooks/useAnimatedIcon/index.js";
import { ArrowDown02Linear } from "../../../../../Iconsax/ArrowDown02Linear.js";
import { ArrowUp02Linear } from "../../../../../Iconsax/ArrowUp02Linear.js";
import { ICONSAX_SIZE } from "../../../../../Iconsax/Iconsax.types.js";
import { useSidebar } from "../../../../Sidebar.context.js";
import { SidebarItemBody } from "../SidebarItemBody/SidebarItemBody.component.js";
import { StyledSidebarItem } from "../../SidebarItem.style.js";
import { SidebarItemCoreProps } from "./SidebarItemCore.types.js";

export const SidebarItemCore = ({
    id,
    label,
    icon,
    animatedIcon,
    subMenu,
    onClick,
    disabled,
    badge,
    rightComponent,
    isOpen,
    onToggleOpen,
}: SidebarItemCoreProps) => {
    const { transitionState, selected } = useSidebar();
    const { AnimatedIcon, handleMouseEnter, handleMouseLeave } = useAnimatedIcon({
        jsonAnimationData: animatedIcon,
        initialDelay: 100,
        repeatDelay: 1000,
        colorInherit: true,
    });

    const handleItemClick = (event: MouseEvent | KeyboardEvent) => {
        if (subMenu && subMenu.isOpen === undefined) {
            onToggleOpen();
        }
        onClick({ id, label, subMenu, icon, onClick, disabled }, event);
    };

    return (
        <div onMouseEnter={animatedIcon ? handleMouseEnter : undefined} onMouseLeave={animatedIcon ? handleMouseLeave : undefined}>
            <StyledSidebarItem
                role="menuitem"
                onClick={handleItemClick}
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        handleItemClick(event);
                    }
                }}
                tabIndex={0}
                disabled={(disabled && disabled.disabled) || false}
                selected={subMenu ? subMenu.entries.some((sb) => sb.id === selected) || selected === id : selected === id}
            >
                <SidebarItemBody
                    label={label}
                    icon={icon}
                    animatedIconNode={animatedIcon ? AnimatedIcon : undefined}
                    badge={badge}
                    disabled={disabled}
                    rightComponent={rightComponent}
                />
                {!!subMenu?.entries?.length && transitionState === "entered" && (
                    <div style={{ marginLeft: "auto" }}>
                        {isOpen ? <ArrowUp02Linear size={ICONSAX_SIZE.SMALL} /> : <ArrowDown02Linear size={ICONSAX_SIZE.SMALL} />}
                    </div>
                )}
            </StyledSidebarItem>
        </div>
    );
};
